import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 15000, // 15s default — prevents infinite hangs from backend issues
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper for long-running AI calls (generation, research)
api.aiPost = (url, data) => api.post(url, data, { timeout: 120000 }); // 120s for AI

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect on invite accept — let the component show the error
      const url = error.config?.url || '';
      if (!url.includes('/org/invite/')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
